import { memo } from "react";
import * as Styled from "./style";
import { useRouter } from "next/router";
import { PATHS } from "~/const/paths";
import { useAuth } from "~/provider/auth";

type WatchAccessControlProps = {
  /** ブロック対象が作品詳細のヘッダーかどうかを判定する */
  isBlockDetailHeader: boolean;
};

export const WatchAccessControl = memo(({ isBlockDetailHeader }: WatchAccessControlProps) => {
  const { isLoggedIn, profileId, execAuth } = useAuth();
  const { push } = useRouter();

  const headerName = isBlockDetailHeader && !isLoggedIn ? "表示制限" : "視聴制限";

  const headerTextByLoggedIn = isLoggedIn ? (
    <>
      <p>年齢制限のある作品です。</p>
      <p>現在の設定では視聴できません。</p>
    </>
  ) : (
    <>
      <p>年齢制限のある作品です。</p>
      <p>この作品を表示するにはログインしてください。</p>
    </>
  );

  const headerContentText = isBlockDetailHeader ? (
    headerTextByLoggedIn
  ) : (
    <>
      <p>年齢制限のあるページです。</p>
      <p>現在の設定では視聴できません。</p>
    </>
  );

  const settingButtonName = isLoggedIn ? "設定" : "ログイン";
  const goToSetting = async () => {
    if (isLoggedIn) {
      await push({
        // @ts-expect-error 今後型が修正するため起こらない
        pathname: PATHS.PROFILE_EDIT,
        query: {
          // @ts-expect-error 今後型が修正するため起こらない
          profileId: profileId,
        },
      });
    } else {
      execAuth();
    }
  };

  const goToTop = async () => {
    await push({
      pathname: PATHS.VOD,
    });
  };

  return (
    <Styled.DivRootFlexCenter>
      <Styled.DivWrapper>
        <Styled.IconHeading
          name="audienceSlash"
          size="XXXL"
          color="GRAY500"
          isBlockDetailHeader={isBlockDetailHeader}
        />
        <Styled.DivDescriptionWrapper>
          <Styled.DivHeading>{headerName}</Styled.DivHeading>
          <Styled.DivDescription>{headerContentText}</Styled.DivDescription>
        </Styled.DivDescriptionWrapper>

        <Styled.DivButtonDescription isBlockDetailHeader={isBlockDetailHeader}>
          <Styled.SettingAccessButton
            type="button"
            name={"setting-button"}
            onClick={goToSetting}
            isBlockDetailHeader={isBlockDetailHeader}
          >
            {settingButtonName}
          </Styled.SettingAccessButton>
          <Styled.TopAccessButton
            type="button"
            name={"top-button"}
            onClick={goToTop}
            isBlockDetailHeader={isBlockDetailHeader}
          >
            トップへ移動
          </Styled.TopAccessButton>
        </Styled.DivButtonDescription>
      </Styled.DivWrapper>
    </Styled.DivRootFlexCenter>
  );
});

WatchAccessControl.displayName = "WatchAccessControl";
